<ui-card>
    <div class="ui">
        <app-segment-header
            title="{{ 'applicant-tracker.applicants.hiringDetails' | appTranslate }}"
        ></app-segment-header>
    </div>
    <div class="flex wrap">
        <div>
            <h4 class="heading">{{ 'applicant-tracker.applicants.employeeProfile' | appTranslate }}</h4>
            <!-- TODO: replace this with the linked employee name -->
            <div>{{ applicant?.connectEmployeeLink?.employeeFullName || 'None' }}</div>
        </div>

        <div class="margin-left-5">
            <h4 class="heading">{{ 'applicant-tracker.applicants.offerAcceptedDate' | appTranslate }}</h4>
            <div>
                {{ (applicant?.connectEmployeeLink?.offerAcceptedDate | date: 'mediumDate') || 'N/A' }}
                <ui-info
                    *ngIf="!applicant?.connectEmployeeLink?.offerAcceptedDate"
                    [matTooltipClass]="'allow-multi-line-tooltip'"
                    [text]="'An offer letter has not been accepted within Humi.'"
                ></ui-info>
            </div>
        </div>

        <div class="margin-left-5">
            <h4 class="heading">
                {{ 'applicant-tracker.applicants.timeToHire' | appTranslate }}
                <ui-info
                    [matTooltipClass]="'allow-multi-line-tooltip'"
                    [text]="
                        'Time to hire measures the amount of time that passes between when the employee applied to the job and the date they accepted the offer.'
                    "
                ></ui-info>
            </h4>
            <div>
                {{ applicant?.connectEmployeeLink?.timeToHire ?? 'N/A' }}
                <ui-info
                    *ngIf="!applicant?.connectEmployeeLink?.timeToHire"
                    [matTooltipClass]="'allow-multi-line-tooltip'"
                    [text]="'Can’t calculate time to hire because an offer letter has not been accepted within Humi.'"
                ></ui-info>
            </div>
        </div>

        <div class="margin-left-5">
            <h4 class="heading">
                {{ 'applicant-tracker.applicants.timeToFill' | appTranslate }}
                <ui-info
                    [matTooltipClass]="'allow-multi-line-tooltip'"
                    [text]="
                        'Time to fill measures the amount of time that passes between when the job posting was created and the date the employee accepted the offer.'
                    "
                ></ui-info>
            </h4>
            <div>
                {{ applicant?.connectEmployeeLink?.timeToFill ?? 'N/A' }}
                <ui-info
                    *ngIf="!applicant?.connectEmployeeLink?.timeToFill"
                    [matTooltipClass]="'allow-multi-line-tooltip'"
                    [text]="'Can’t calculate time to fill because an offer letter has not been accepted within Humi. '"
                ></ui-info>
            </div>
        </div>
    </div>
</ui-card>
